const registerDeviceScreenMessages = {
    deviceQuery :'Which device are you using?',
    serialNumberLabel : 'Enter the unique serial number printed on your device.',
    serialNumberPosInfo : 'Find the serial number positioned here:',
};

export default registerDeviceScreenMessages;